import OrderRequest from '../../../../../../types/api/order-request'
import renderDatetime from '../../../../../../helpers/tables/render-datetime'
import { ColumnsType } from 'antd/es/table'
import OrderActions from '../../order-form/order-actions'
import MaterialInCuttingIndicator from '../../../../../../components/material-in-cutting-indicator/material-in-cutting-indicator'
import { Space } from 'antd'

export const columns: ColumnsType<OrderRequest> = [
    {
        title: 'Номер заявки',
        dataIndex: 'id',
        width: 45,
    },
    {
        title: 'Дата создания',
        dataIndex: 'createdAt',
        width: 100,
        render: (v: string) => {
            return v ? renderDatetime(v) : undefined
        },
    },
    {
        title: 'Статус',
        dataIndex: 'requestStatus',
        width: 70,
    },
    {
        title: 'Инициатор',
        dataIndex: ['initiator', 'username'],
        width: 150,
    },
    {
        title: 'Кол-во',
        dataIndex: 'amount',
        width: 90,
        render: (value, record) => {
            const unitName = record.unit ? record.unit.shortName : ''
            return `${value} ${unitName}`
        },
    },
    {
        title: 'Материал',
        children: [
            {
                title: 'Ширина',
                dataIndex: ['material', 'width'],
                width: 220,
            },

            {
                title: 'Тип',
                dataIndex: ['material', 'material_type', 'name'],
                width: 220,
                render: (value, record) => {
                    if (record.material?.material_type?.materialInCutting) {
                        return (
                            <Space size={4}>
                                {value}
                                <MaterialInCuttingIndicator />
                            </Space>
                        )
                    }
                    return value
                },
            },
        ],
    },
    {
        title: 'Действия',
        width: 70,
        render: (value, record) => {
            return <OrderActions order={record} />
        },
    },
]
